module.exports = __webpack_public_path__ + "media/Inpainting_Removal.136aed1c.webm";